import ComponentLayout from '~/src/layouts/component-layout';
import { Link, Text, Box } from '@primer/react';
import { Link as GatsbyLink } from 'gatsby';
import { AccessibilityLink } from '~/src/components/accessibility-link';
import * as React from 'react';
export default {
  ComponentLayout,
  Link,
  Text,
  Box,
  GatsbyLink,
  AccessibilityLink,
  React
};